import PropTypes from 'prop-types';
import React from 'react';

const BookmarkGraphic = ({ colorFill = 'none', stroke = '#4A4A4A' }) => {
  return (
    <svg
      width="20px"
      height="24px"
      viewBox="0 0 20 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fillRule="evenodd">
        <g
          transform="translate(-1035.000000, -320.000000)"
          fill={colorFill}
          stroke={stroke}
        >
          <polygon points="1036.11188 321.034025 1036.11188 321.162358 1036.11188 327.191092 1036.11188 343.034025 1045.11188 337.312558 1054.11188 343.034025 1054.11188 321.034025"></polygon>
        </g>
      </g>
    </svg>
  );
};

BookmarkGraphic.propTypes = {
  colorFill: PropTypes.string,
  stroke: PropTypes.string,
};

export default BookmarkGraphic;
